import React from 'react';

const TermsPage = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
        <p className="text-gray-600 mt-2">Terms and conditions of use</p>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-700">
          This is the Terms of Service page. Content will be implemented here.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
